<template>
  <div>
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <div class="row flex-row no-gutter mt-4">
      <div class="col d-flex">
        <RentalObjectContracts class="flex-fill" :rentalObjectId="rentalObjectId" />
      </div>

      <div class="col d-flex mt-5 mt-lg-0">
        <RentalObjectTakeOverProtocols class="flex-fill" :rentalObjectId="rentalObjectId" />
      </div>
    </div>

    <div class="mt-5"></div>

    <div class="row big-gutter mt-5">
      <div class="col"></div>

      <div class="col mt-5 mt-lg-0"></div>
    </div>
  </div>
</template>

<script>
import RentalObjectContracts from '@/components/detailedRentalObject/RentalObjectContracts.vue';
import RentalObjectTakeOverProtocols from '@/components/detailedRentalObject/RentalObjectTakeoverProtocols.vue';

export default {
  props: {
    rentalObjectId: [Number, String],
    defaultHeader: String,
  },

  components: {
    RentalObjectContracts,
    RentalObjectTakeOverProtocols,
  },
};
</script>

<style lang="scss">
a:hover {
  text-decoration: none;
  color: inherit;
}

.see-edit {
  text-decoration: none;
  color: inherit;

  i {
    font-size: 1.2rem;
  }
}
</style>
